import { Component, Input, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { Chart } from 'chart.js';
import { ReportGenSvc, ReportWithDatesRequest } from 'src/app/services_autogenerated/generated_services';
import { forkJoin, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'app-sales-estimate',
    templateUrl: './sales-estimate.component.html',
    styleUrls: ['./sales-estimate.component.css'],
    standalone: false
})
export class SalesEstimateComponent extends BaseReportCardComponent implements OnInit {
  @Input() backlogColor: string = 'rgb(33, 37, 41)';  
  @Input() completeAndUnpaidColor: string = 'rgb(33, 37, 41)';
  @Input() completeAndPaidColor: string = 'rgb(33, 37, 41)';
  @Input() commissionLostColor: string = 'rgb(33, 37, 41)';
  
  salesLoading: boolean = true;

  commissionLostTotal: number;
  completeAndPaidTotal: number;
  completeAndUnpaidTotal: number;
  backlogTotal: number;

  salesGoal: number;
  salesTotal: number;

  constructor(private reportService: ReportGenSvc) {
    super();
  }

  ngOnInit() {
    this.salesGoal = this.employee.salesGoal ? this.employee.salesGoal : 850000;

    var afterDate =  new Date(new Date().getFullYear(), 0, 1);
    const request: ReportWithDatesRequest = new ReportWithDatesRequest({
      id: !this.companyWide ? this.employee.id : null,
      afterDate: afterDate,
      beforeDate: new Date()
    });

    forkJoin([
      this.reportService.getCommissionLost(request).pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      ), 
      this.reportService.getCompletedPaidTotals(request).pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      ),
      this.reportService.getPastDue(request).pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      ),
      this.reportService.getBacklogTotals(request).pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      ),
    ])
    .subscribe(res => {
      this.commissionLostTotal = res[0].reduce((acc, curr) => acc + curr.total, 0);
      this.completeAndPaidTotal = res[1].wellnessCurrentRange + res[1].workCurrentRange;
      this.completeAndUnpaidTotal = res[2].underThirtyTotal + res[2].thirtyToSixtyTotal + res[2].overSixtyTotal
      this.backlogTotal = res[3].wellnessCurrentRange + res[3].workCurrentRange;
      this.createChart();
      this.salesTotal = this.completeAndPaidTotal + this.completeAndUnpaidTotal + this.backlogTotal - this.commissionLostTotal;
      this.salesLoading = false
    });
  }

  createChart() {
    // Calculate total active positive segments
    const positiveSum = this.completeAndPaidTotal + this.completeAndUnpaidTotal + this.backlogTotal;
    // Minimum cap height for the container frame
    const baseTargetHeight = this.salesGoal + 10000; 

    // The background should only fill the remaining gap. If data exceeds the cap, gap is 0.
    const backgroundFiller = positiveSum >= baseTargetHeight ? 0 : baseTargetHeight - positiveSum;

    // Dynamic max calculation so that the Y-axis auto-expands if data shoots past the cap
    const dynamicYMax = Math.max(baseTargetHeight, positiveSum);

    new Chart(document.getElementById("chartjs-7"), {
      type: "bar",
      data: {
        datasets: [
        {
          // label: "Complete & Unpaid",
          backgroundColor: "rgb(154,152,111)",
          data: [this.completeAndUnpaidTotal],
          xAxisID: "bar-x-axis1",
          yAxisID: "bar-y-axis1",
          stack: '0'
        },
        {
          // label: "Complete & Paid",
          data: [this.completeAndPaidTotal],
          backgroundColor: "rgb(97,116,86)",
          xAxisID: "bar-x-axis1",
          yAxisID: "bar-y-axis1",
          stack: '0'
        },
        {
          // label: "In Backlog",
          data: [this.backlogTotal],
          backgroundColor: "rgb(155,119,167)",
          xAxisID: "bar-x-axis1",
          yAxisID: "bar-y-axis1",
          stack: '0'
        },
        {
          // label: "Background",
          data: [backgroundFiller],
          backgroundColor: "rgb(169,169,169)",
          xAxisID: "bar-x-axis1",
          yAxisID: "bar-y-axis1",
          stack: '0'
        },
        {
          // label: "Commission Lost Jobs",
          data: [-this.commissionLostTotal],
          backgroundColor: "rgb(171,113,112)",
          xAxisID: "bar-x-axis1",
          yAxisID: "bar-y-axis1",
          stack: '0'
        }]
      },
      options: {
        legend: {
          display: false
        },
        events: [],
        scales: {
          xAxes: [{
            stacked: true,
            display: false,
            id: "bar-x-axis1",
          }],
          yAxes: [{
            id: "bar-y-axis1",
            stacked: true,
            ticks: {
              max: dynamicYMax,
              beginAtZero: true,
              stepSize: this.salesGoal / 10,
              callback: (value, index) => {
                // only want to show 0 and the goal as a tick
                var acceptableArray = [0];
                if(!this.companyWide){
                  acceptableArray.push(this.salesGoal)
                }
                if (!acceptableArray.includes(value)) {
                  return undefined;
                }
                if (value > 1000) {
                  return `$${value.toString().slice(0,-3)}k`
                } else {
                  return `$${value}`;
                }
              }
            }
          }]
        }
      }
    });
  }
}
